// @ts-strict-ignore
import styled from "styled-components";
import { HTMLButton } from "components/parts/button";
import { Col, NewRow } from "components/layout/Grid";
import Image from "next/image";

export const NavigationWrapper = styled.div<{
  isOpen?: boolean;
  noPadding?: boolean;
}>`
  z-index: 100;
  top: 0;

  box-sizing: border-box;
  background-color: ${({ theme }) => theme.backgroundColors.primary};
  border-bottom: ${({ isOpen }) => (isOpen ? "1px" : "0")} solid
    ${({ theme }) => theme.textColors.primary};
  position: sticky;
  width: 100%;
  padding: ${({ noPadding }) => (noPadding ? "0" : "0 24px")};
  margin: auto;
  display: none;
  height: auto;
  ${({ theme: { media } }) => media.desktop`
  display: block;
`}
  ${HTMLButton} {
    position: absolute;
    top: 40px;
    right: 40px;

    img {
      width: 50px;
      height: 50px;
      object-fit: contain;
    }
  }
`;

export const MainNavigationContainer = styled(NewRow)`
  display: none;
  height: 60px;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.backgroundColors.primary};
  ${({ theme: { media } }) => media.desktop`
    display: flex;
  `}
`;

export const NavBarLeftContainer = styled(Col)`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  align-items: center;
  justify-content: space-between;
`;

export const NavBarCenterContainer = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NavBarRightContainer = styled(Col)`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
`;

export const MainNavigationContent = styled.nav`
  display: flex;
  align-items: center;
`;

export const NavigationLinks = styled.ul`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 0;
  padding: 0;

  ${({ theme: { media } }) => media.desktop`
    height: 36px;
    align-items: center;
  `}
`;

export const Item = styled.li`
  &:focus {
    button {
      color: #b3b3b4;
    }
  }
  position: relative;
  list-style: none;
  padding: 0;
  outline: none;
  letter-spacing: -0.44px;
  button {
    outline: none;
  }

  ${({ theme: { media } }) => media.desktop`
    perspective: 2000px;
    margin-right: 32px;
    ${({ name }) => (name === "All Products" ? `width: 88px;` : name === "Resources" && `width: 92px;`)}
  `}
`;
